import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { loadSiteConfig } from './site'
import './styles/global.css'

void loadSiteConfig()

createApp(App).use(router).mount('#app')
